import { UUID } from '../types/uuid';
import { IBasicUserInfo } from '../resources/models/IUserInfo';
import { generateLazyContext } from './LazyContext';

export type TLazyUserInfo = Pick<IBasicUserInfo, 'id' | 'first_name' | 'last_name' | 'email'>;

export const LazyUsersContext = generateLazyContext<TLazyUserInfo, UUID>();
